module.exports = __webpack_public_path__ + "img/battery-critical.9bb55546.svg";